interface HolidayShape {
  month: number;
  dayOfWeek: number;
  weekOfMonth: number;
}

const isMovableDateHoliday = (
  holidays: Array<HolidayShape>,
  month: number,
  dayOfWeek: number,
  weekOfMonth: number
): boolean =>
  holidays.some(
    (holiday) =>
      holiday.month === month &&
      holiday.dayOfWeek === dayOfWeek &&
      holiday.weekOfMonth === weekOfMonth
  );

export default isMovableDateHoliday;
